/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import { connect } from "react-redux";
import { LoadingState } from "redux-request-loading";
import { Form, Container, Button, Segment, Grid, IconProps, Modal, List, Icon, Header, Loader } from "semantic-ui-react";

import { mapStateToQuestionnaireContainerProps } from "@teamprevent/common/questionnaires/mappers";
import { ProgressCircle } from "@teamprevent/common/progress-circle";
import { Media } from "@teamprevent/common/responsive";

import { renderQuestionnaireSections, isSectionVisible } from "../utils";
import { nextSection, openSection } from "../actions";
import { QuestionnairesState, Section } from "../model";
import {
    QuestionnaireContainerStateProps, NonAutoSaveQuestionnaireContainerOwnProps, QuestionnaireTypeProps
} from "../QuestionnaireContainerProps";
import { ConfirmedButton } from "../../confirmedButton/ConfirmedButton";
import { toast } from "../../toasts";

import { isClinicalNotesBeingCompletedInAdvance } from "./models";

import "../styles/progress-bar-questionnaire-container.scss";

interface ProgressBarQuestionnaireContainerStateProps extends QuestionnaireContainerStateProps {
    activeSectionId: string;
    sections: Section[];
}

interface ProgressBarQuestionnaireContainerDispatchProps {
    nextSection: (questionnaireKey: string, sectionId: string) => void;
    openSection: (questionnaireKey: string, sectionId: string) => void;
}

type ProgressBarQuestionnaireContainerProps =
    ProgressBarQuestionnaireContainerStateProps &
    NonAutoSaveQuestionnaireContainerOwnProps &
    QuestionnaireTypeProps &
    ProgressBarQuestionnaireContainerDispatchProps;

interface State {
    mobileProgressModalOpen: boolean;
    sections: Section[];
    activeSectionIndex: number;
}

class ProgressBarQuestionnaireContainerUnconnected extends React.Component<ProgressBarQuestionnaireContainerProps, State> {

    private progressBarQuestionnaireRef: React.RefObject<HTMLDivElement>;

    constructor(props: ProgressBarQuestionnaireContainerProps) {
        super(props);
        this.state = { mobileProgressModalOpen: false, sections: [], activeSectionIndex: 0 };
        this.navigateToNextSection = this.navigateToNextSection.bind(this);
        this.submitQuestionnaire = this.submitQuestionnaire.bind(this);
        this.closeMobileModal = this.closeMobileModal.bind(this);
        this.openMobileModal = this.openMobileModal.bind(this);
    }

    public componentDidMount() {
        this.props.loadQuestionnaire();
        this.progressBarQuestionnaireRef = React.createRef();
        this.setSectionsInState(this.props.sections);
    }

    public componentDidUpdate(prevProps: ProgressBarQuestionnaireContainerProps) {
        if (this.props.sections?.some(s => s.active) !== true) {
            const firstSection = this.props.sections?.find(isSectionVisible);
            if (firstSection) {
                this.props.openSection(this.props.questionnaireKey, firstSection.id);
            }
        }

        if (this.props.sections !== prevProps.sections) {
            this.setSectionsInState(this.props.sections);
        }
    }

    public render() {
        if (this.props.loading) {
            return (
                <Loader active />
            );
        }

        return (
            <Container>
                <Form className="questionnaire">
                    <Segment basic>
                        {!this.props.hideBreadcrumbBar &&
                            this.renderProgressBreadcrumbBar()
                        }
                        {renderQuestionnaireSections(this.props, this.props.children)}
                    </Segment>
                    {this.renderSubmitButton()}
                </Form>
            </Container>
        );
    }

    public setSectionsInState(sections: Section[]) {
        const visibleSections = (sections || []).filter(isSectionVisible);

        const activeSectionIndex = visibleSections.findIndex(s => s.id === this.props.activeSectionId);

        this.setState({
            sections: visibleSections,
            activeSectionIndex
        });
    }

    public async submitQuestionnaire() {
        if (!this.props.submittingQuestionnaire) {
            const submitted = await this.props.submitQuestionnaire(this.props.questions);

            if (submitted) {
                try {
                    if (this.props.task && this.props.removeAppointment && isClinicalNotesBeingCompletedInAdvance(this.props.task)) {
                        this.props.removeAppointment(this.props.task.caseId, this.props.task.id);
                    }
                } catch {
                    toast.error("Something went wrong during removing the appointment");
                }
            }
        }
    }

    private openMobileModal() {
        this.setState({ mobileProgressModalOpen: true });
    }

    private closeMobileModal() {
        this.setState({ mobileProgressModalOpen: false });
    }

    private renderProgressBreadcrumbBar() {
        if (this.props.readonly) {
            return null;
        }
        const { sections, activeSectionIndex } = this.state;

        return (
            <div ref={this.progressBarQuestionnaireRef}>
                <Media lessThan="computer">
                    {sections &&
                        <Modal
                            open={this.state.mobileProgressModalOpen}
                            onClose={this.closeMobileModal}
                            trigger={
                                <Segment className="step-segment" basic floated="right">
                                    <Button size="mini" type="button" onClick={this.openMobileModal}>
                                        <Icon name="bars" />
                                        Step {activeSectionIndex + 1} of {sections.length}
                                    </Button>
                                </Segment>
                            }
                            size="small"
                            closeIcon
                            className="mobile-questionnaire-progress-modal"
                        >
                            <Header content={`Step ${activeSectionIndex + 1} of ${sections.length}`} />
                            <Modal.Content>
                                <List>
                                    {sections.map((s, i) =>
                                        (<List.Item key={s.id} onClick={this.generateOpenSectionAndCloseMobileProgressModal(s.id)}>
                                            <Icon {...this.getMobileBreadCrumbIcon(s, i, activeSectionIndex)} />
                                            <List.Content>{s.title}</List.Content>
                                        </List.Item>))}
                                </List>
                            </Modal.Content>
                        </Modal>
                    }
                </Media>
                <Segment as={Media} greaterThanOrEqual="computer" basic>
                    <Grid floated="right" textAlign="center">
                        <Grid.Row columns="equal" className="questionnaire-progress-bar">
                            {sections && sections.map((s, i) =>
                                (<Grid.Column
                                    key={s.id}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={() => this.props.openSection(this.props.questionnaireKey, s.id)}
                                    className={this.getCssClassForSection(s, i, activeSectionIndex)}
                                >
                                    <ProgressCircle width="15" height="15" />
                                    <div className="title">{i + 1}</div>
                                </Grid.Column>)
                            )}
                        </Grid.Row>
                    </Grid>
                </Segment>
            </div>
        );
    }

    private renderSubmitButton() {
        if (this.props.readonly) {
            return null;
        }

        return (
            <Container>
                {this.state.activeSectionIndex !== this.state.sections.length - 1
                    ? <Form.Button
                        type="button"
                        onClick={this.navigateToNextSection}
                        content="Next"
                    />
                    : !this.props.hideSubmitButton &&
                    <Form.Field>
                        {this.props.otherActionButtons}
                        {this.props.submissionConfirmationText ?
                            <ConfirmedButton
                                content="Submit"
                                className="submit"
                                onClick={this.submitQuestionnaire}
                                promptText={this.props.submissionConfirmationText}
                                loading={this.props.submittingQuestionnaire}
                                disabled={this.props.submittingQuestionnaire}
                                confirmButtonColor="green"
                            /> :
                            <Button
                                content="Submit"
                                className="submit"
                                onClick={this.submitQuestionnaire}
                                loading={this.props.submittingQuestionnaire}
                                disabled={this.props.submittingQuestionnaire}
                            />
                        }
                    </Form.Field>
                }
            </Container>
        );
    }

    private generateOpenSectionAndCloseMobileProgressModal(sectionId: string) {
        return () => {
            this.props.openSection(this.props.questionnaireKey, sectionId);
            this.setState({ mobileProgressModalOpen: false });
        };
    }

    private navigateToNextSection() {
        this.props.nextSection(this.props.questionnaireKey, this.props.activeSectionId);
        this.progressBarQuestionnaireRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    private getCssClassForSection(section: Section, sectionIndex: number, activeSectionIndex: number): string {
        const futureSection = sectionIndex > activeSectionIndex;
        const pastSection = sectionIndex < activeSectionIndex;
        const currentSection = sectionIndex === activeSectionIndex;
        if (futureSection) {
            return "empty";
        } else if (!section.isValid && (pastSection || section.isComplete)) {
            return "error";
        } else if (currentSection) {
            return "active";
        } else {
            return "done";
        }
    }

    private getMobileBreadCrumbIcon(section: Section, index: number, activeSectionIndex: number): IconProps {
        if (section.id === this.props.activeSectionId) {
            return { name: "circle", className: "active-section" };
        } else if (index > activeSectionIndex) {
            return { name: "circle", color: "grey" };
        } else if (section.isValid) {
            return { name: "check circle", color: "green" };
        }

        return { name: "times circle", color: "red" };
    }
}

const mapStateToProps = (
    state: { questionnaires: QuestionnairesState; router: Location } & LoadingState,
    ownProps: NonAutoSaveQuestionnaireContainerOwnProps & QuestionnaireTypeProps): ProgressBarQuestionnaireContainerStateProps => {
    const questionnaire = state.questionnaires[ownProps.questionnaireKey];
    const activeSection = questionnaire?.sections.find(s => s.active);

    return {
        ...mapStateToQuestionnaireContainerProps(state, ownProps),
        sections: questionnaire?.sections,
        activeSectionId: activeSection?.id
    };
};

const mapDispatchToProps = (dispatch: any): ProgressBarQuestionnaireContainerDispatchProps => ({
    nextSection: (questionnaireKey: string, sectionId: string) => dispatch(nextSection({ questionnaireKey, sectionId })),
    openSection: (questionnaireKey: string, sectionId: string) => dispatch(openSection({ questionnaireKey, sectionId, closeOthers: true }))
});

/**
 * @deprecated Used by PhysiotherapyMgrReferral only.
 * Replaced by OldProgressBarQuestionnaireContainer & ContextAwareProgressBarQuestionnaireContainer.
 * Prefer ContextAwareProgressBarQuestionnaireContainer
 */
export const ClassBasedProgressBarQuestionnaireContainer = connect(mapStateToProps, mapDispatchToProps)(ProgressBarQuestionnaireContainerUnconnected);
